/** In-memory session cache for derived Notes lock key (never persisted). */
const SESSION_TTL_MS = 5 * 60 * 1000;
let cachedKey = null;
let cachedAt = 0;
let idleTimer = null;
function clearIdleTimer() {
    if (idleTimer !== null) {
        clearTimeout(idleTimer);
        idleTimer = null;
    }
}
function scheduleExpiry() {
    clearIdleTimer();
    idleTimer = setTimeout(() => {
        clearNotesLockSession();
    }, SESSION_TTL_MS);
}
/** Store derived key in memory for the session window. */
export function setNotesLockSessionKey(key) {
    cachedKey = key;
    cachedAt = Date.now();
    scheduleExpiry();
}
/** Touch session to extend idle timeout. */
export function touchNotesLockSession() {
    if (cachedKey)
        scheduleExpiry();
}
/** Read cached key if session is still valid. */
export function getNotesLockSessionKey() {
    if (!cachedKey)
        return null;
    if (Date.now() - cachedAt > SESSION_TTL_MS) {
        clearNotesLockSession();
        return null;
    }
    return cachedKey;
}
/** Clear cached key from memory. */
export function clearNotesLockSession() {
    cachedKey = null;
    cachedAt = 0;
    clearIdleTimer();
}
